"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isReplaceSubscriptionErrorResponse = exports.ReplaceSubscriptionFailedEvent = exports.Name = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'replace-subscription-failed';
const ReplaceSubscriptionFailedEvent = exports.ReplaceSubscriptionFailedEvent = Name;
const isReplaceSubscriptionErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isReplaceSubscriptionErrorResponse = isReplaceSubscriptionErrorResponse;
